import React from 'react';

const LoadingDots = () => {
    // Inline styles for the animation behavior
    const keyframes = `
        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1.1); }
        }
      `;

    // Base styling for each dot
    const dotStyle = (delay) => ({
        width: '6px',
        height: '6px',
        backgroundColor: 'var(--theme-color-main)', // Modern tech blue (or use 'currentColor' to inherit text color)
        borderRadius: '50%',
        display: 'inline-block',
        animation: 'pulse 1.4s infinite ease-in-out both',
        animationDelay: delay,
    });

    return (
        <span style={{display: 'inline-flex', alignItems: 'center', gap: '3px', height: '1rem'}} className={"ml-2"}>
            <style>{keyframes}</style>
              <span style={dotStyle('0s')}/>
              <span style={dotStyle('0.2s')}/>
              <span style={dotStyle('0.4s')}/>
        </span>
    )
}

export default LoadingDots;